export default "__VITE_ASSET__BViD4JxM__"